import moment from "moment";
import { AnalyticsList, DataAccess, UserGroupPermissions, SubscriptionType, WaterdataGroup } from "../types/userGroupPermissions";

export function userGroupValidation(waterdataGroup: WaterdataGroup | null, subscriptionType: SubscriptionType | null, dateRange: string, confidentialDatasetIds: string[]): UserGroupPermissions {

  const timeRange = dateRange.split(';'); // "1979-01-01 00:00:00;2021-12-31 23:00:00"

  if (waterdataGroup === WaterdataGroup.WD_Users) {
    switch (subscriptionType) {
      case SubscriptionType.AnalyticsOnly:
        return {
          waterdataGroup: waterdataGroup,
          subscriptionType: subscriptionType,
          analyticsList: AnalyticsList.all,
          dataAccess: DataAccess.buy,
          dateRange: dateRangeLimit(timeRange),
          analyticsDateRange: dateRangeLimit(timeRange),
          validationDateRange: dateRangeLimit(timeRange),
          confidentialDatasetIds: confidentialDatasetIds,
          spectraAccess: false
        }
      case SubscriptionType.DataOnly:
        return {
          waterdataGroup: waterdataGroup,
          subscriptionType: subscriptionType,
          analyticsList: AnalyticsList.all,
          dataAccess: DataAccess.buy,
          dateRange: dateRangeLimit(timeRange),
          analyticsDateRange: dateRangeLimit(timeRange, 1),
          validationDateRange: dateRangeLimit(timeRange),
          confidentialDatasetIds: confidentialDatasetIds,
          spectraAccess: true
        }
      case SubscriptionType.Unlimited:
        return {
          waterdataGroup: waterdataGroup,
          subscriptionType: subscriptionType,
          analyticsList: AnalyticsList.all,
          dataAccess: DataAccess.buy,
          dateRange: dateRangeLimit(timeRange),
          analyticsDateRange: dateRangeLimit(timeRange),
          validationDateRange: dateRangeLimit(timeRange),
          confidentialDatasetIds: confidentialDatasetIds,
          spectraAccess: true
        }
      case SubscriptionType.Bronze:
        return {
          waterdataGroup: waterdataGroup,
          subscriptionType: subscriptionType,
          analyticsList: AnalyticsList.all,
          dataAccess: DataAccess.buy,
          dateRange: dateRangeLimit(timeRange),
          analyticsDateRange: dateRangeLimit(timeRange),
          validationDateRange: dateRangeLimit(timeRange),
          confidentialDatasetIds: confidentialDatasetIds,
          spectraAccess: false
        }
      case SubscriptionType.Silver:
        return {
          waterdataGroup: waterdataGroup,
          subscriptionType: subscriptionType,
          analyticsList: AnalyticsList.all,
          dataAccess: DataAccess.buy,
          dateRange: dateRangeLimit(timeRange),
          analyticsDateRange: dateRangeLimit(timeRange),
          validationDateRange: dateRangeLimit(timeRange),
          confidentialDatasetIds: confidentialDatasetIds,
          spectraAccess: false
        }
      case SubscriptionType.Gold:
        return {
          waterdataGroup: waterdataGroup,
          subscriptionType: subscriptionType,
          analyticsList: AnalyticsList.all,
          dataAccess: DataAccess.buy,
          dateRange: dateRangeLimit(timeRange),
          analyticsDateRange: dateRangeLimit(timeRange),
          validationDateRange: dateRangeLimit(timeRange),
          confidentialDatasetIds: confidentialDatasetIds,
          spectraAccess: false
        }
      default:
        return {
          waterdataGroup: waterdataGroup,
          subscriptionType: subscriptionType,
          analyticsList: AnalyticsList.all,
          dataAccess: DataAccess.buy,
          dateRange: dateRangeLimit(timeRange),
          analyticsDateRange: dateRangeLimit(timeRange, 1),
          validationDateRange: dateRangeLimit(timeRange),
          confidentialDatasetIds: confidentialDatasetIds,
          spectraAccess: false
        }
    }
  }
  if (waterdataGroup === WaterdataGroup.DHI_Users ||
    waterdataGroup === WaterdataGroup.Metocean_Plus ||
    waterdataGroup === WaterdataGroup.MOOD_Admin ||
    waterdataGroup === WaterdataGroup.SpecialData_Users) {
    return {
      waterdataGroup: waterdataGroup,
      subscriptionType: subscriptionType,
      analyticsList: AnalyticsList.all,
      dataAccess: DataAccess.buy,
      dateRange: dateRangeLimit(timeRange),
      analyticsDateRange: dateRangeLimit(timeRange),
      validationDateRange: dateRangeLimit(timeRange),
      confidentialDatasetIds: confidentialDatasetIds,
      spectraAccess: true
    }

  }

  return {
    waterdataGroup: null,
    subscriptionType: null,
    analyticsList: AnalyticsList.limited,
    dataAccess: DataAccess.buy,
    dateRange: dateRangeLimit(timeRange),
    analyticsDateRange: dateRangeLimit(timeRange, 1),
    validationDateRange: dateRangeLimit(timeRange),
    confidentialDatasetIds: confidentialDatasetIds,
    spectraAccess: false
  }
}

export function dateRangeLimit(
  timeRange: string[],
  limit?: number
) {
  const startDate = moment(timeRange[0])
  const endDate = moment(timeRange[1])

  let range: [moment.Moment, moment.Moment] = [startDate, endDate];
  if (!limit || limit === 0) return range;

  const start = startDate;
  const end = endDate;
  const rangeLimit = end.clone().subtract(limit, 'years');

  range = [rangeLimit, end];
  if (rangeLimit.isBetween(start, end)) {
    return range;
  }

  range = [start, end];
  return range;
}

